import { MutationTree } from 'vuex';
import { EDocumentType } from '@lib-shared/enums/document-type';
import { ECreatePageMutation } from '@/document-manipulator/create-page/store/create-page.constants';
import { ICreatePageState } from '@/document-manipulator/create-page/store/create-page.types';
import { IDocumentPage } from '@lib-shared/types/document-page';
import { IDocument } from '@lib-shared/types/Document';

export const mutations: MutationTree<ICreatePageState> = {
  [ECreatePageMutation.SetState](state: ICreatePageState, newState: ICreatePageState) {
    state.createdPage = newState.createdPage;
    state.createdDocumentType = newState.createdDocumentType;
    state.createdDocument = newState.createdDocument;
    state.creating = newState.creating;
  },
  [ECreatePageMutation.SetCreatedPage](state: ICreatePageState, page: IDocumentPage) {
    state.createdPage = page;
  },
  [ECreatePageMutation.SetCreatedDocument](state: ICreatePageState, document: IDocument) {
    state.createdDocument = document;
  },
  [ECreatePageMutation.SetCreatedDocumentType](state: ICreatePageState, type: EDocumentType) {
    state.createdDocumentType = type;
  },
  [ECreatePageMutation.SetCreating](state: ICreatePageState, creating: boolean) {
    state.creating = creating;
  },
};
